export interface Asset {
  id: string;
  assetTag: string;
  name: string;
  category: AssetCategory;
  type: string;
  status: AssetStatus;
  owner: string;
  assignedTo?: string;
  location: string;
  department?: string;
  purchaseDate: string;
  purchaseCost: number;
  currency: string;
  vendor?: string;
  warrantyExpiry?: string;
  serialNumber?: string;
  model?: string;
  manufacturer?: string;
  specifications?: Record<string, any>;
  licenseKey?: string;
  licenseExpiry?: string;
  maintenanceSchedule?: string;
  lastMaintenanceDate?: string;
  depreciation?: DepreciationInfo;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export enum AssetCategory {
  HARDWARE = 'hardware',
  SOFTWARE = 'software',
  NETWORK = 'network',
  INFRASTRUCTURE = 'infrastructure',
  MOBILE_DEVICE = 'mobile-device',
  PERIPHERALS = 'peripherals',
  LICENSE = 'license',
}

export enum AssetStatus {
  UNKNOWN = 'unknown',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  IN_MAINTENANCE = 'in-maintenance',
  RETIRED = 'retired',
  DISPOSED = 'disposed',
  LOST = 'lost',
  STOLEN = 'stolen',
}

export interface DepreciationInfo {
  method: 'straight-line' | 'declining-balance';
  usefulLife: number; // in years
  salvageValue: number;
  currentValue: number;
  depreciationRate: number;
}

export interface AssetCollection {
  assets: Asset[];
  total_entries: number;
}

export interface AssetFilter {
  category?: AssetCategory;
  status?: AssetStatus;
  owner?: string;
  location?: string;
  search?: string;
}

export interface AssetStatistics {
  totalAssets: number;
  totalValue: number;
  byCategory: Record<AssetCategory, number>;
  byStatus: Record<AssetStatus, number>;
  expiringWarranties: Asset[];
  expiringLicenses: Asset[];
  maintenanceDue: Asset[];
}
